module.exports = __webpack_public_path__ + "static/img/12.f4065c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/12.png
// module id = uCRx
// module chunks = 0